import { render } from "./MetasProducao.vue?vue&type=template&id=710181c0&scoped=true"
import script from "./MetasProducao.vue?vue&type=script&lang=js"
export * from "./MetasProducao.vue?vue&type=script&lang=js"

import "./MetasProducao.vue?vue&type=style&index=0&id=710181c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710181c0"]])

export default __exports__